export const palletColors = {
  purple: '#8D16E7',
  green: '#16e96e',
  greenNeon: '#00FF47',
  red: '#CE0000',
  blue: '#0090CE',
  blueDark: '#0085FF',
  yellow: '#FFF505',
  yellowDark: '#FFC805',
  cyan: '#3C3C3C',
};
